export default __webpack_public_path__ + "static/media/plusSignLeft.a56e2ec0.svg";